module.exports = __webpack_public_path__ + "static/media/stofferingen-54.6b1f3078.jpg";